export const dashboard_table_columns = [
  {
    key: "operator_name",
    label: "Representative",
    size: 9,
  },
  {
    key: "team",
    label: "Team",
    size: 3,
  },
  // {
  //   key: "department",
  //   label: "Department",
  // },
  {
    key: "average_grade",
    label: "Grade",
    size: 3,
  },
  {
    key: "team_grade",
    label: "Team Grade",
    size: 3,
  },
  {
    key: "actions",
    label: "",
    size: 1,
  },
];

export const calls_table_columns = [
  {
    key: "checkbox",
    label: "",
    size: 1,
  },
  {
    key: "play_button",
    label: "",
    size: 1,
  },
  {
    key: "call_id",
    label: "#",
    size: 6,
  },
  {
    key: "operator_name",
    label: "Representative",
    size: 5,
  },
  // {
  //   key: "team",
  //   label: "Team",
  //   size: 3,
  // },
  {
    key: "call_timestamp",
    label: "Date",
    sortable: true,
    size: 4,
  },
  {
    key: "duration",
    label: "Durée",
    size: 3,
  },
  {
    key: "department",
    label: "Department",
    size: 4,
  },
  {
    key: "call_purpose",
    label: "Subject",
    size: 4,
  },
  // {
  //   key : team_grade,
  //   label : "Team Grade",
  //   sortable : true,
  //    size: 4,
  // },
  {
    key: "grade",
    label: "Grade",
    sortable: true,
    size: 4,
  },
  {
    key: "client_number",
    label: "Client Phone",
    size: 4,
  },
];

export const representatives_table_columns = [
  {
    key: "operator_name",
    label: "Representative",
    sortable: true,
    size: 8,
  },
  {
    key: "team",
    label: "Team",
    sortable: true,
    size: 4,
  },
  {
    key: "department",
    label: "Department",
    sortable: true,
    size: 4,
  },
  {
    key: "nb_calls",
    label: "Total calls",
    sortable: true,
    size: 3,
  },
  // {
  //   key: "nb_incoming",
  //   label: "Incoming calls",
  //   sortable: true,
  //   size: 8,
  // },
  // {
  //   key: "nb_outgoing",
  //   label: "Outgoing calls",
  //   sortable: true,
  //   size: 8,
  // },
  {
    key: "nb_frustrated",
    label: "Frustrated (%)",
    sortable: true,
    size: 3,
  },
  {
    key: "nb_frustrated_calls",
    label: "Frustrated",
    sortable: true,
    size: 3,
  },
  {
    key: "team_grade",
    label: "Team Grade",
    sortable: true,
    size: 2,
  },
  {
    key: "grade",
    label: "Individual Grade",
    sortable: true,
    size: 2,
  },
  {
    key: "actions",
    label: "",
    size: 1,
  },
];

export const live_content_search_table_columns = [
  {
    key: "checkbox",
    label: "",
    size: 1,
  },
  {
    key: "play_button",
    label: "",
    size: 1,
  },
  {
    key: "call_id",
    label: "#",
    size: 4,
  },
  {
    key: "operator_name",
    label: "Representative",
    size: 4,
  },
  {
    key: "call_timestamp",
    label: "Date",
    sortable: true,
    size: 4,
  },
  {
    key: "duration",
    label: "Durée",
    size: 3,
  },
  {
    key: "client_number",
    label: "Phone Number",
    size: 4,
  },
  {
    key: "result",
    label: "Result",
    size: 10,
  },
  // {
  //   key: "nb_hits",
  //   label: "Number of occurences",
  //   size: 1,
  // },
];

export const financial_insights_table_columns = [
  {
    key: "name",
    label: "Representative",
    size: 9,
  },
  {
    key: "team",
    label: "Team",
    size: 3,
  },
  // {
  //   key: "outgoing_calls_count",
  //   label: "Calls / day",
  // },
  {
    key: "revenue",
    label: "Total Sales",
    size: 3,
  },
];

export const financial_details_table_columns = [
  {
    key: "name",
    label: "Representative",
    sortable: true,
    size: 8,
  },
  {
    key: "team",
    label: "Team",
    sortable: true,
    size: 4,
  },
  {
    key: "department",
    label: "Department",
    sortable: true,
    size: 4,
  },
  // {
  //   key: "outgoing_calls_count",
  //   label: "Calls / day",
  //   sortable: true,
  // },
  {
    key: "revenue",
    label: "Total Sales",
    sortable: true,
    size: 4,
  },
  {
    key: "actions",
    label: "",
    size: 1,
  },
];

export const getAdminSettingsTableColumns = (cx_provider) => [
  {
    key: "name",
    label: "Representative",
    sortable: true,
    size: 4,
  },
  {
    key: "role",
    label: "Role",
    sortable: true,
    size: 2,
  },
  {
    key: "department",
    label: "Department",
    sortable: true,
    size: 3,
  },
  {
    key: "team",
    label: "Team",
    sortable: true,
    size: 3,
  },
  {
    key: "localisation",
    label: "Localisation",
    sortable: true,
    size: 3,
  },
  ...(cx_provider === "3cx"
    ? [
        {
          key: "extension_3cx",
          label: "Extension 3CX",
          sortable: true,
          size: 1,
        },
      ]
    : []),
  ...(cx_provider === "aircall"
    ? [
        {
          key: "extension_aircall",
          label: "Aircall ID",
          sortable: true,
          size: 1,
        },
      ]
    : []),
  ...(cx_provider === "sftp_hsf"
    ? [
        {
          key: "cx_one_identifier",
          label: "CX One ID",
          sortable: true,
          size: 1,
        },
      ]
    : []),
  {
    key: "active",
    label: "",
    sortable: false,
    size: 1,
    alignEnd: true,
  },
];
